module.exports = __webpack_public_path__ + "img/kn.c5e69ac3.svg";